import type { RouteLocationNormalized } from "vue-router";

export default [
  {
    path: "/backoffice/replenishment/cron-schedule",
    name: "ReplenishmentCronSchedule",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Replenishment" },
        { label: "Cron Schedule" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "replenishment" */ "@/views/backoffice/Replenishment/CronSchedule.vue"
      ),
  },
  {
    path: "/backoffice/replenishment/programs",
    name: "ReplenishmentProgramsList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Replenishment" },
        { label: "Programs" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "replenishment" */ "@/views/backoffice/Replenishment/ProgramsList.vue"
      ),
  },
  {
    path: "/backoffice/replenishment/programs/:id/edit",
    name: "ReplenishmentProgramEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: (_route: RouteLocationNormalized) => [
        { label: "BackOffice", to: "/" },
        { label: "Replenishment" },
        { label: "Programs", to: "/backoffice/replenishment/programs" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "replenishment" */ "@/views/backoffice/Replenishment/ProgramEdit.vue"
      ),
  },
];
